import { Outlet, useRouteLoaderData } from '@remix-run/react'
import { InstallPrompt } from '#app/components/install-prompt.js'
import { Navbar } from '#app/components/navbar.js'
import { type loader as rootLoader } from '#app/root.js'

/**
 * Pathless layout route that owns the global chrome (header + footer) for the
 * main chat app. The sibling `embed.tsx` route (for the embedded widget) does
 * not nest under this layout and therefore skips the chrome entirely.
 *
 * The `#new-chat-slot` div lives in the Navbar component so that
 * NewChatButton's createPortal target is present whenever a chrome-wrapped
 * route is mounted.
 */
export default function AppLayout() {
	const data = useRouteLoaderData<typeof rootLoader>('root')
	const isSignedIn = data?.isSignedIn ?? false
	const authUrl = data?.ENV.AUTH_URL ?? ''

	return (
		<div className="flex h-dvh flex-col justify-between">
			<Navbar isSignedIn={isSignedIn} authUrl={authUrl} />
			<Outlet />
			<InstallPrompt />
		</div>
	)
}
